/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProceedingParticipantType } from './ProceedingParticipantType';
import {
    ProceedingParticipantTypeFromJSON,
    ProceedingParticipantTypeFromJSONTyped,
    ProceedingParticipantTypeToJSON,
    ProceedingParticipantTypeToJSONTyped,
} from './ProceedingParticipantType';

/**
 * 
 * @export
 * @interface ProceedingParticipantResponse
 */
export interface ProceedingParticipantResponse {
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    proceedingParticipantId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProceedingParticipantResponse
     */
    isGlobal: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    owningClientId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProceedingParticipantResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    deactivationReason: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProceedingParticipantResponse
     */
    deactivatedAtUtc: Date | null;
    /**
     * 
     * @type {ProceedingParticipantType}
     * @memberof ProceedingParticipantResponse
     */
    type: ProceedingParticipantType;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    country: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    note: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    mergeHistory: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProceedingParticipantResponse
     */
    lastChangedAtUtc?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    lastChangedByUserCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantResponse
     */
    deactivatedByUserCode?: string | null;
}



/**
 * Check if a given object implements the ProceedingParticipantResponse interface.
 */
export function instanceOfProceedingParticipantResponse(value: object): value is ProceedingParticipantResponse {
    if (!('proceedingParticipantId' in value) || value['proceedingParticipantId'] === undefined) return false;
    if (!('isGlobal' in value) || value['isGlobal'] === undefined) return false;
    if (!('owningClientId' in value) || value['owningClientId'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('deactivationReason' in value) || value['deactivationReason'] === undefined) return false;
    if (!('deactivatedAtUtc' in value) || value['deactivatedAtUtc'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('mergeHistory' in value) || value['mergeHistory'] === undefined) return false;
    return true;
}

export function ProceedingParticipantResponseFromJSON(json: any): ProceedingParticipantResponse {
    return ProceedingParticipantResponseFromJSONTyped(json, false);
}

export function ProceedingParticipantResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProceedingParticipantResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'proceedingParticipantId': json['proceedingParticipantId'],
        'isGlobal': json['isGlobal'],
        'owningClientId': json['owningClientId'],
        'isActive': json['isActive'],
        'deactivationReason': json['deactivationReason'],
        'deactivatedAtUtc': (json['deactivatedAtUtc'] == null ? null : new Date(json['deactivatedAtUtc'])),
        'type': ProceedingParticipantTypeFromJSON(json['type']),
        'name': json['name'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'country': json['country'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'note': json['note'],
        'mergeHistory': json['mergeHistory'],
        'lastChangedAtUtc': json['lastChangedAtUtc'] == null ? undefined : (new Date(json['lastChangedAtUtc'])),
        'lastChangedByUserCode': json['lastChangedByUserCode'] == null ? undefined : json['lastChangedByUserCode'],
        'deactivatedByUserCode': json['deactivatedByUserCode'] == null ? undefined : json['deactivatedByUserCode'],
    };
}

export function ProceedingParticipantResponseToJSON(json: any): ProceedingParticipantResponse {
    return ProceedingParticipantResponseToJSONTyped(json, false);
}

export function ProceedingParticipantResponseToJSONTyped(value?: ProceedingParticipantResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'proceedingParticipantId': value['proceedingParticipantId'],
        'isGlobal': value['isGlobal'],
        'owningClientId': value['owningClientId'],
        'isActive': value['isActive'],
        'deactivationReason': value['deactivationReason'],
        'deactivatedAtUtc': value['deactivatedAtUtc'] == null ? value['deactivatedAtUtc'] : value['deactivatedAtUtc'].toISOString(),
        'type': ProceedingParticipantTypeToJSON(value['type']),
        'name': value['name'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'country': value['country'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'note': value['note'],
        'mergeHistory': value['mergeHistory'],
        'lastChangedAtUtc': value['lastChangedAtUtc'] == null ? value['lastChangedAtUtc'] : value['lastChangedAtUtc'].toISOString(),
        'lastChangedByUserCode': value['lastChangedByUserCode'],
        'deactivatedByUserCode': value['deactivatedByUserCode'],
    };
}

